// ======================================================================
// File: indentColumns.js
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Column definition for Indent list table
// - Stateless configuration file
//
// ======================================================================

import INDENT_STATUS from "../enums/indentStatus";
import { formatDate } from "../../../../../../utils/formatUtils";

const indentColumns = [
  {
    key: "indent_no",
    title: "Indent No",
  },
  {
    key: "indent_date",
    title: "Date",
    render: (row) => formatDate(row.indent_date),
  },
  {
    key: "indent_type",
    title: "Type",
  },
  {
    key: "indent_source",
    title: "Source",
  },
  {
    key: "department_name",
    title: "Department",
  },
  {
    key: "status",
    title: "Status",
    render: (row) => (
      <span className={`status-${row.status}`}>
        {row.status}
      </span>
    ),
  },
  {
    key: "actions",
    title: "Actions",
    render: (row, ctx) => {
      const { navigate, canEdit } = ctx;

      return (
        <div className="erp-table-actions">
          {/* VIEW */}
          <button
            className="btn-link"
            onClick={() =>
              navigate(
                `/ppe/procurement/indent/${row.id}`
              )
            }
          >
            View
          </button>

          {/* EDIT */}
          {canEdit &&
            row.status ===
              INDENT_STATUS.DRAFT && (
              <button
                className="btn-link"
                onClick={() =>
                  navigate(
                    `/ppe/procurement/indent/${row.id}?edit=true`
                  )
                }
              >
                Edit
              </button>
            )}
        </div>
      );
    },
  },
];

export default indentColumns;
